module.exports = __webpack_public_path__ + "img/black_fishing_a001_title.aac29a1d.png";